<template>
  <div class="messageWrap bgcScN2">
    <div v-if="show" class="boxWrap rowJcAc">
      <div class="detailBox flexCol">
        <div class="rowAs">
          <div>
            <img
              v-if="newsData.type == 8"
              src="../../assets/static/message/system.svg"
              class="moduleItemImg"
              alt=""
            />
            <img
              v-else
              src="../../assets/static/message/wechat.svg"
              class="moduleItemImg"
              alt=""
            />
          </div>
          <div>
            <div class="popupTitle fontScN8 fontH2">{{ newsData.title }}</div>
            <div class="popupTime fontScN6 fontH4">
              {{ newsData.createTime }}
            </div>
          </div>
        </div>
        <div class="popupText fontH3 fontScN7" v-html="newsData.note"></div>
        <div class="popupBtn fontMcA1 fontH2 rowJcAc" @click="closePopup">
          我知道了
        </div>
      </div>
    </div>

    <!-- 图片 -->
    <div class="imgBox rowJc bgcScW">
      <img
        src="../../assets/static/message/messagePic.png"
        class="bannerImg"
        alt=""
      />
    </div>
    <!-- 消息通知 -->
    <div class="newsBox bgcScW flexCol">
      <div class="newsTitle fontH2 fontScN8 rowAc">消息通知</div>
      <div class="flexBox">
        <div class="campusBox" v-for="(item, index) in newsList" :key="index">
          <div class="campusName bgcScN2 rowAc">
            <div class="campusIcon icon-campus fontScN7 fontH2"></div>
            <div class="campusText fontScN7 fontH3">{{ item.campusName }}</div>
          </div>
          <div
            class="newsItem rowAc"
            v-for="(item1, index1) in item.noticeTodoTrackingRespVos"
            :key="index1"
            @click="showPopup(item1, index, index1)"
          >
            <div class="newsImgBox">
              <img
                class="moduleItemImg"
                src="../../assets/static/message/system.svg"
                alt=""
              />
              <div v-if="item1.isRead == 0" class="dot"></div>
            </div>
            <div class="rightBox">
              <div class="rowJbAc">
                <div class="itemTitle fontScN8 fontH2">{{ item1.title }}</div>
                <div class="itemTime fontScN6 fontH4">
                  {{ item1.createTime }}
                </div>
              </div>
              <div class="newsText fontH3 fontScN6">{{item1.summary}}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="noNews fontH3 fontScN8 rowJcAc"
        v-if="newsList && newsList.length == 0"
      >
        <div class="colAc">
          <img
            class="noMessage"
            src="../../assets/static/message/noMessage.svg"
            alt=""
          />
          <div class="fontH3 fontScN7">暂无消息</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageListAPI, readNewsAPI } from "../../utils/api/api";
export default {
  data() {
    return {
      newsList: [], //消息通知数组
      newsData: {}, //消息通知弹框
      show: false, //弹框

      campus: "",
      campusCode: "",
      parentUid: "",
    };
  },
  mounted() {
    this.getList();
  },
  created() {
    var selectedCampus = {};
    // if (this.$common.getCache("campusItem")) {
    //   // 判断本地有无校区信息
    //   var selectedCampus = JSON.parse(this.$common.getCache("campusItem"));
    // } else {
    //   var campusList = JSON.parse(this.$common.getCache("customerAuthList"));
    //   if (campusList) {
    //     var selectedCampus = campusList[0];
    //   }
    // }
    if(this.$common.getCache('customerAuthList')) {
      var campusList = JSON.parse(this.$common.getCache('customerAuthList'))
      if(campusList && campusList.length != 0) {
          var idx = campusList.findIndex(item => {return item.campusCode == JSON.parse(this.$common.getCache("customerInfo")).campusCode})
          selectedCampus = idx == '-1' ? campusList[0] : campusList[idx]
          this.$common.setCache('campusItem',idx == '-1' ? JSON.stringify(campusList[0]) : JSON.stringify(campusList[idx]))
      }
    }else {
        selectedCampus = JSON.parse(this.$common.getCache("customerInfo"))
        selectedCampus.campusName = selectedCampus.institutionName+'-'+selectedCampus.campusName
        this.$common.setCache('campusItem',JSON.stringify(selectedCampus))
    }
    console.log('selectedCampus',selectedCampus)
    this.campus = selectedCampus.campusName;
    this.campusCode = selectedCampus.campusCode;
    this.parentUid = selectedCampus.customerId;
  },
  methods: {
    showPopup(item1, index, index1) {
      this.newsData = JSON.parse(JSON.stringify(item1));
      // var newNote = this.newsData.note.split("<ZzmMark/>").join("<br/>");
      // this.newsData["note"] = newNote;
      console.log("item",this.newsData);
      // this.show = true;
      if (item1.isRead == 0) {
        readNewsAPI({ id: item1.id }).then((res) => {
          if (res.resultCode == 200) {
            this.newsList[index].noticeTodoTrackingRespVos[index1].isRead = 1;
            this.getList();
          }
        });
      }
      this.$router.push({name: 'MessageInform',params:{newsData:this.newsData}})
    },
    onClose() {
      this.show = false;
    },
    closePopup() {
      this.show = false;
    },
    // 判断时间为今天
    judgeTime(data) {
      // console.log('判断时间为今天',data)
      var date = data.toString();
      var year = date.substring(0, 4);
      var month = date.substring(5, 7);
      var day = date.substring(8, 10);
      var d1 = new Date(year + "/" + month + "/" + day);
      var dd = new Date();
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      var d2 = new Date(y + "/" + m + "/" + d);
      var iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
      return iday;
    },
    getList() {
      getMessageListAPI().then((res) => {
        if (res.resultCode == 200) {
          console.log("消息列表", res.data);
          this.newsList = [];
          if (res.data) {
            res.data.forEach((item) => {
              if (item.noticeTodoTrackingRespVos) {
                item.noticeTodoTrackingRespVos.forEach((item1) => {
                  var time = this.judgeTime(item1.createTime);
                  if (time == 0) {
                    item1.createTime = item1.createTime
                      .split(" ")[1]
                      .substring(0, 5);
                  } else if (time == 1) {
                    item1.createTime = "昨天";
                  } else if (time == 2) {
                    item1.createTime = "前天";
                  } else {
                    item1.createTime =
                      item1.createTime.substring(5, 7) +
                      "月" +
                      item1.createTime.substring(8, 10) +
                      "日";
                  }
                });
              }
            });
            this.newsList = res.data ? res.data : [];
            console.log("处理后的数组", this.newsList);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.messageWrap {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.imgBox {
  // width: 100%;
  padding: 0.16rem;
  box-sizing: border-box;
  .bannerImg {
    // width: 3.4rem;
    // height: 1rem;
    width: 100%;
  }
}
.newsBox {
  width: 100%;
  height: calc(100% - 1.44rem);
  // height: 100%;
  padding: 0.12rem 0.16rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  margin-top: 12px;
  .newsTitle {
    font-weight: 500;
    margin-bottom: 12px;
  }
  .campusName {
    width: 100%;
    height: 32px;
    margin-bottom: 17px;
    padding: 0 0.11rem;
    box-sizing: border-box;
    .campusIcon {
      margin-right: 3px;
    }
    .campusText {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .newsItem {
    position: relative;
    margin-bottom: 23px;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #ff4d4f;
      position: absolute;
      top: -3px;
      left: 38px;
    }
    .rightBox {
      flex: 1;
    }
    .newsText {
      margin-top: 1px;
      width: 2.66rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.moduleItemImg {
  width: 44px;
  height: 44px;
  margin-right: 12px;
}
.noNews {
  width: 100%;
  height: calc(100% - 35px);
  // height: inherit;
}
.popupTitle {
  margin-bottom: 6px;
}
.van-popup--center {
  width: 311px;
  height: 360px;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
}
.popupText {
  // max-height: 193px;
  flex: 1;
  margin-top: 16px;
  overflow: auto;
}

.noMessage {
  width: 84px;
  height: 84px;
  margin-bottom: 8px;
}
/deep/ .van-overlay {
  z-index: 10000 !important;
}
/deep/ .van-popup.van-popup--center {
  z-index: 10000 !important;
}
.flexBox {
  overflow: auto;
}
.boxWrap {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
  .detailBox {
    height: 360px;
    padding: 20px;
    box-sizing: border-box;
    width: calc(100% - 0.64rem);
    background: #ffffff;
    border-radius: 16px;
    position: relative;
  }
}
.popupBtn {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: #e6f5ff;
  font-weight: 500;
}


</style>